import * as React from "react"

import { IconSvgProps } from "@/types"

export const Logo: React.FC<IconSvgProps> = ({
  size = 48,
  width,
  height,
  fill = "currentColor",
  ...props
}) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 32 32"
    width={size || width}
    {...props}
  >
    <path
      fill={fill}
      d="M25.904 14.224v-2.297l-5.718-5.718h-8.263l-5.855 5.855v7.891l5.89 5.89h8.058l5.726-5.725v-3.95l-7.188-6.554H13.36l-3.517 3.425 4.761 5.13 1.772-.773-3.696-4.15 1.489-1.543h3.335l6.087 5.57.055 2.001-4.49 4.435h-6.658L8.113 19.07l-.056-6.426 4.49-4.49h6.68l6.677 6.071Z"
    />
    <path
      fill={fill}
      d="m15.653 13.947 1.552-.797 4.919 4.603.01.844-3.69 3.534-5.406-.13L9.574 18.5v-3.244l2.127 1.658-.018.794 2.668 2.398 3.356-.066 2.12-2.106-4.174-3.987Z"
    />
  </svg>
)

export const LogoWithText: React.FC<IconSvgProps> = ({
  size = 227,
  width,
  height,
  ...props
}) => (
  <svg fill="none" height={size || height} width={size || width} {...props}>
    <path
      fill="#fff"
      d="M181.594 83.643V67.362l-40.519-40.52h-58.56l-41.49 41.491v55.922l41.745 41.746h57.102l40.577-40.578V97.427l-50.938-46.44h-36.82l-24.923 24.27 33.744 36.36 12.556-5.48-26.19-29.407 10.55-10.941h23.636l43.133 39.469.393 14.187-31.824 31.431h-47.18l-31.07-32.902-.393-45.534 31.824-31.823h47.339l47.308 43.026Z"
    />
    <path
      fill="#AA45EC"
      d="m108.953 81.682 10.997-5.654 34.857 32.621.077 5.982-26.153 25.043-38.314-.923-24.547-24.809V90.956l15.076 11.751-.131 5.624 18.913 16.996 23.783-.47 15.018-14.922-29.576-28.253Z"
    />
    <path
      fill="#fff"
      d="M28.311 205.126c-.469 0-.9-.118-1.295-.352a2.767 2.767 0 0 1-.926-.926 2.493 2.493 0 0 1-.352-1.296v-8.182c0-.469.117-.895.352-1.277.234-.395.543-.71.926-.944a2.487 2.487 0 0 1 1.295-.352H39.03v2.462h-10.2a.688.688 0 0 0-.482.167c-.11.111-.166.271-.166.481v7.109c0 .197.055.357.166.481a.692.692 0 0 0 .482.166h10.2v2.463H28.311Zm23.275 0-4.017-4.795h3.203l3.48 4.11v.685h-2.666Zm-10.626 0v-13.311h10.737c.47 0 .901.118 1.296.352.395.235.71.549.944.944a2.4 2.4 0 0 1 .352 1.277v3.592c0 .469-.117.901-.352 1.296-.234.395-.549.709-.944.944a2.6 2.6 0 0 1-1.296.333l-8.293.019v4.554H40.96Zm2.666-7.035h7.96a.271.271 0 0 0 .167-.056.175.175 0 0 0 .074-.148v-3.406a.175.175 0 0 0-.074-.148.231.231 0 0 0-.167-.074h-7.96a.231.231 0 0 0-.167.074.2.2 0 0 0-.055.148v3.406a.2.2 0 0 0 .055.148c.05.037.105.056.167.056Zm12.647 7.035V194.37c0-.469.118-.895.352-1.277.234-.395.543-.71.926-.944a2.488 2.488 0 0 1 1.295-.352h8.164c.47 0 .901.117 1.296.352.395.234.71.549.944.944.235.382.352.808.352 1.277v10.756H67.14v-4.48h-8.423v4.48h-2.444Zm2.444-6.924h8.423v-3.721a.175.175 0 0 0-.074-.148.232.232 0 0 0-.167-.074h-7.96a.231.231 0 0 0-.166.074.2.2 0 0 0-.056.148v3.721Zm13.031 6.924v-13.329h12.274v2.462H74.21v2.962h7.887v2.48H74.21v5.425h-2.462Zm18.298 0v-10.867h-5.442v-2.462h13.328v2.462h-5.424v10.867h-2.462Zm17.447 0c-.469 0-.901-.118-1.296-.352a2.768 2.768 0 0 1-.925-.926 2.488 2.488 0 0 1-.352-1.296v-1.018h2.443v.907c0 .062.019.118.056.167a.27.27 0 0 0 .167.055h7.978a.2.2 0 0 0 .148-.055.227.227 0 0 0 .074-.167v-2.536a.174.174 0 0 0-.074-.148.2.2 0 0 0-.148-.056h-8.071c-.469 0-.901-.117-1.296-.351a2.768 2.768 0 0 1-.925-.926 2.521 2.521 0 0 1-.352-1.314v-2.74c0-.469.117-.895.352-1.277.234-.395.543-.71.925-.944a2.488 2.488 0 0 1 1.296-.352h8.182c.469 0 .895.117 1.278.352.395.234.709.549.944.944.234.382.352.808.352 1.277v1.018h-2.463v-.907a.174.174 0 0 0-.074-.148.176.176 0 0 0-.148-.074h-7.978a.231.231 0 0 0-.167.074.2.2 0 0 0-.056.148v2.536a.2.2 0 0 0 .056.148.271.271 0 0 0 .167.056h8.089c.469 0 .895.117 1.278.352.395.234.709.549.944.944.234.382.352.814.352 1.296v2.739c0 .469-.118.901-.352 1.296a2.718 2.718 0 0 1-.944.926 2.404 2.404 0 0 1-1.278.352h-8.182Zm17.553 0v-10.867h-5.443v-2.462h13.329v2.462h-5.424v10.867h-2.462Zm9.307 0V194.37c0-.469.118-.895.352-1.277a2.71 2.71 0 0 1 .926-.944 2.488 2.488 0 0 1 1.296-.352h8.163c.469 0 .901.117 1.296.352.395.234.71.549.944.944.235.382.352.808.352 1.277v10.756h-2.462v-4.48h-8.423v4.48h-2.444Zm2.444-6.924h8.423v-3.721a.176.176 0 0 0-.074-.148.231.231 0 0 0-.167-.074h-7.96a.23.23 0 0 0-.166.074.2.2 0 0 0-.056.148v3.721Zm13.031 6.924v-13.329h10.737c.469 0 .901.117 1.296.352.395.234.71.549.944.944.235.382.352.808.352 1.277v8.182c0 .469-.117.901-.352 1.296a2.71 2.71 0 0 1-.944.926 2.498 2.498 0 0 1-1.296.352h-10.737Zm2.648-2.463h7.978a.27.27 0 0 0 .167-.055.231.231 0 0 0 .074-.167v-7.96a.176.176 0 0 0-.074-.148.231.231 0 0 0-.167-.074h-7.978a.231.231 0 0 0-.167.074.2.2 0 0 0-.055.148v7.96a.27.27 0 0 0 .055.167.27.27 0 0 0 .167.055Zm12.495 2.463v-13.329h2.425v13.329h-2.425Zm6.755 0c-.469 0-.901-.118-1.296-.352a2.77 2.77 0 0 1-.926-.926 2.498 2.498 0 0 1-.352-1.296v-10.755h2.444v10.644c0 .062.018.118.056.167a.267.267 0 0 0 .166.055h7.96a.27.27 0 0 0 .167-.055.231.231 0 0 0 .074-.167v-10.644h2.462v10.755c0 .469-.117.901-.352 1.296a2.71 2.71 0 0 1-.944.926 2.398 2.398 0 0 1-1.277.352h-8.182Zm12.794 0v-13.329h2.684l4.832 5.757 4.813-5.757h2.703v13.329h-2.462v-9.775l-5.054 6.017-5.073-5.998v9.756h-2.443Z"
    />
  </svg>
)

export const LogoAuth: React.FC<IconSvgProps> = (props) => (
  <svg width={80} height={80} fill="none" {...props}>
    <path
      fill="#fff"
      d="M64.76 35.56v-5.743L50.464 15.522H29.806L15.17 30.16v19.729l14.727 14.726h20.145L64.355 50.3v-9.876L46.385 24.04H33.396l-8.792 8.562 11.904 12.827 4.43-1.934-9.24-10.373 3.722-3.86h8.338l15.217 13.924.138 5.004L47.887 59.28H31.242L20.282 47.67l-.139-16.063L31.37 20.382h16.7L64.76 35.56Z"
    />
    <path
      fill="#AA45EC"
      d="m39.133 34.868 3.88-1.994 12.296 11.508.027 2.11-9.226 8.835L32.594 55l-8.66-8.752V38.14l5.319 4.146-.047 1.983 6.673 5.997 8.39-.166 5.298-5.264-10.434-9.968Z"
    />
  </svg>
)

export const DiscordIcon: React.FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
    >
      <path
        d="M14.82 4.26a10.14 10.14 0 0 0-.53 1.1 14.66 14.66 0 0 0-4.58 0 10.14 10.14 0 0 0-.53-1.1 16 16 0 0 0-4.13 1.3 17.33 17.33 0 0 0-3 11.59 16.6 16.6 0 0 0 5.07 2.59A12.89 12.89 0 0 0 8.23 18a9.65 9.65 0 0 1-1.71-.83 3.39 3.39 0 0 0 .42-.33 11.66 11.66 0 0 0 10.12 0q.21.18.42.33a10.84 10.84 0 0 1-1.71.84 12.41 12.41 0 0 0 1.08 1.78 16.44 16.44 0 0 0 5.06-2.59 17.22 17.22 0 0 0-3-11.59 16.09 16.09 0 0 0-4.09-1.35zM8.68 14.81a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.93 1.93 0 0 1 1.8 2 1.93 1.93 0 0 1-1.8 2zm6.64 0a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.92 1.92 0 0 1 1.8 2 1.92 1.92 0 0 1-1.8 2z"
        fill="currentColor"
      />
    </svg>
  )
}

export const TwitterIcon: React.FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 1200 1226.37"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M714.163 519.284 1160.89 0h-105.86L667.137 450.887 357.328 0H0l468.492 681.821L0 1226.37h105.866l409.625-476.152 327.181 476.152H1200L714.137 519.284h.026ZM569.165 687.828l-47.468-67.894-377.686-540.24h162.604l304.797 435.991 47.468 67.894 396.2 566.721H892.476L569.165 687.854v-.026Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const GithubIcon: React.FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M12.026 2c-5.509 0-9.974 4.465-9.974 9.974 0 4.406 2.857 8.145 6.821 9.465.499.09.679-.217.679-.481 0-.237-.008-.865-.011-1.696-2.775.602-3.361-1.338-3.361-1.338-.452-1.152-1.107-1.459-1.107-1.459-.905-.619.069-.605.069-.605 1.002.07 1.527 1.028 1.527 1.028.89 1.524 2.336 1.084 2.902.829.091-.645.351-1.085.635-1.334-2.214-.251-4.542-1.107-4.542-4.93 0-1.087.389-1.979 1.024-2.675-.101-.253-.446-1.268.099-2.64 0 0 .837-.269 2.742 1.021a9.582 9.582 0 0 1 2.496-.336 9.554 9.554 0 0 1 2.496.336c1.906-1.291 2.742-1.021 2.742-1.021.545 1.372.203 2.387.099 2.64.64.696 1.024 1.587 1.024 2.675 0 3.833-2.33 4.675-4.552 4.922.355.308.675.916.675 1.846 0 1.334-.012 2.41-.012 2.737 0 .267.178.577.687.479C19.146 20.115 22 16.379 22 11.974 22 6.465 17.535 2 12.026 2z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}

export const MoonFilledIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M21.53 15.93c-.16-.27-.61-.69-1.73-.49a8.46 8.46 0 01-1.88.13 8.409 8.409 0 01-5.91-2.82 8.068 8.068 0 01-1.44-8.66c.44-1.01.13-1.54-.09-1.76s-.77-.55-1.83-.11a10.318 10.318 0 00-6.32 10.21 10.475 10.475 0 007.04 8.99 10 10 0 002.89.55c.16.01.32.02.48.02a10.5 10.5 0 008.47-4.27c.67-.93.49-1.519.32-1.79z"
      fill="currentColor"
    />
  </svg>
)

export const SunFilledIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <g fill="currentColor">
      <path d="M19 12a7 7 0 11-7-7 7 7 0 017 7z" />
      <path d="M12 22.96a.969.969 0 01-1-.96v-.08a1 1 0 012 0 1.038 1.038 0 01-1 1.04zm7.14-2.82a1.024 1.024 0 01-.71-.29l-.13-.13a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.984.984 0 01-.7.29zm-14.28 0a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a1 1 0 01-.7.29zM22 13h-.08a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zM2.08 13H2a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zm16.93-7.01a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a.984.984 0 01-.7.29zm-14.02 0a1.024 1.024 0 01-.71-.29l-.13-.14a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.97.97 0 01-.7.3zM12 3.04a.969.969 0 01-1-.96V2a1 1 0 012 0 1.038 1.038 0 01-1 1.04z" />
    </g>
  </svg>
)

export const XRoundIcon = ({
  size = 48,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg width={size || width} height={size || height} fill="none" {...props}>
    <rect width={48} height={48} fill="#141414" rx={24} />
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        d="M25.688 22.157 34.25 12h-2.029l-7.434 8.82L18.849 12H12l8.98 13.336L12 35.988h2.03l7.85-9.314 6.271 9.314H35l-9.312-13.83Zm-2.779 3.297-.91-1.328-7.239-10.567h3.117l5.842 8.528.91 1.328L32.221 34.5h-3.116l-6.197-9.046Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M12 12h23v24H12z" />
      </clipPath>
    </defs>
  </svg>
)

export const DiscordRoundIcon = ({ ...props }: IconSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    {...props}
  >
    <rect width={48} height={48} fill="#5865F2" rx={24} />
    <path
      fill="#fff"
      d="M34.824 14.01A26.19 26.19 0 0 0 28.291 12c-.308.552-.588 1.12-.837 1.701a24.331 24.331 0 0 0-7.25 0A18.003 18.003 0 0 0 19.367 12a26.375 26.375 0 0 0-6.538 2.015c-4.134 6.117-5.255 12.082-4.695 17.963A26.335 26.335 0 0 0 16.147 36a19.35 19.35 0 0 0 1.716-2.767 17.042 17.042 0 0 1-2.702-1.29c.226-.165.448-.334.662-.498a18.823 18.823 0 0 0 16.02 0c.217.176.438.346.663.498-.863.51-1.77.942-2.708 1.292A19.183 19.183 0 0 0 31.514 36a26.214 26.214 0 0 0 8.018-4.02c.657-6.82-1.124-12.73-4.708-17.97ZM18.573 28.361c-1.562 0-2.852-1.417-2.852-3.16 0-1.744 1.245-3.174 2.847-3.174 1.601 0 2.881 1.43 2.854 3.174-.027 1.743-1.258 3.16-2.85 3.16Zm10.52 0c-1.564 0-2.849-1.417-2.849-3.16 0-1.744 1.245-3.174 2.85-3.174 1.603 0 2.874 1.43 2.846 3.174-.027 1.743-1.255 3.16-2.847 3.16Z"
    />
  </svg>
)

export const ArrowDownsLineIcon = ({ ...props }: IconSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m12 13.171 4.95-4.95 1.414 1.415L12 16 5.636 9.636 7.05 8.222l4.95 4.95Z" />
  </svg>
)
